/* eslint-env jquery */

"use strict";

const defaultAnimationTime = 300;

const initListeners = () => {
    const setPosition = ($carousel) => {
        const $mainSlider = $carousel.find(".main-slick-wrapper .slick");
        const $secondarySlider = $carousel.find(".secondary-slick-wrapper .slick");

        $mainSlider.slick("setPosition");
        $secondarySlider.slick("setPosition");
    };

    $(".js-open-product-info").on("click", function () {
        $(this).closest(".js-ahumada-products-carousel").attr("show-product-info", true);
        setPosition($(this).closest(".js-ahumada-products-carousel"));
    });

    $(".js-close-product-info").on("click", function () {
        $(this).closest(".js-ahumada-products-carousel").attr("show-product-info", false);
        setPosition($(this).closest(".js-ahumada-products-carousel"));
    });

    $(".js-ahumada-products-carousel .main-slick-wrapper .slick").on("beforeChange", function (_event, _slick, _currentSlide, _nextSlide) {
        $(this).closest(".js-ahumada-products-carousel").attr("slide-changing", true);

        setTimeout(() => {
            $(this).closest(".js-ahumada-products-carousel").attr("slide-changing", false);
        }, defaultAnimationTime);
    });

    $(".js-ahumada-products-carousel .main-slick-wrapper .slick").on("afterChange", function (_event, _slick, _currentSlide, _nextSlide) {
        $(this).closest(".js-ahumada-products-carousel").find(".secondary-slick-wrapper .js-product-info-slider").slick("slickGoTo", 0);
    });

    $(".js-ahumada-products-carousel .secondary-slick-wrapper  .js-product-info-slider").on("afterChange", function (_event, _slick, _currentSlide, _nextSlide) {
        setPosition($(this).closest(".js-ahumada-products-carousel"));
    });
};

window.addEventListener("load", () => {
    if (!window.ahumadaProductsCarouselInitialized) {
        const ahumadaProductsCarousel = $(".js-ahumada-products-carousel");

        ahumadaProductsCarousel.each(function (index, carousel) {
            const mainSlickWrapper = "." + $(carousel).data().id + " .main-slick-wrapper";
            const mainSlickSelector = mainSlickWrapper + " > .slick";
            const mainSlickPrevArrow = mainSlickWrapper + " .slick-prev";
            const mainSlickNextArrow = mainSlickWrapper + " .slick-next";

            const secondarySlickWrapper = "." + $(carousel).data().id + " .secondary-slick-wrapper";
            const secondarySlickSelector = secondarySlickWrapper + " > .slick";
            const secondarySlickPrevArrow = secondarySlickWrapper + " .slick-prev";
            const secondarySlickNextArrow = secondarySlickWrapper + " .slick-next";

            $(mainSlickSelector).slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: true,
                centerMode: true,
                focusOnSelect: true,
                draggable: false,
                swipe: false,
                speed: 0,
                asNavFor: secondarySlickSelector,
                prevArrow: mainSlickPrevArrow,
                nextArrow: mainSlickNextArrow,
                waitForAnimate: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            draggable: true,
                            swipe: true,
                        }
                    }
                ]
            });

            $(secondarySlickSelector).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                adaptiveHeight: true,
                focusOnSelect: false,
                speed: 0,
                asNavFor: mainSlickSelector,
                draggable: false,
                swipe: false,
                waitForAnimate: true,
                prevArrow: secondarySlickPrevArrow,
                nextArrow: secondarySlickNextArrow
            });

            const productInfoSlider = secondarySlickWrapper + " .js-product-info-slider";

            $(productInfoSlider).each(function (index, slider) {
                const $slickDotsRegion = $(slider).closest(".product-info__slider-wrapper").find(".slick-dots-wrapper");

                $(slider).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    adaptiveHeight: true,
                    speed: 300,
                    appendDots: $slickDotsRegion
                });
            });
        });

        window.ahumadaProductsCarouselInitialized = true;
    }

    initListeners();
});
